// utils/getAvatarUrl.js
// getAvatarUrl  → resuelve rutas de avatar a URL absoluta (con default SVG si vacío)
// getUploadUrl  → resuelve cualquier ruta de upload a URL absoluta (sin default)

const DEFAULT_AVATAR = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><linearGradient id="bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#081729"/><stop offset="55%" stop-color="#0d2340"/><stop offset="100%" stop-color="#1DA1F2"/></linearGradient><linearGradient id="accent" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#F5A623"/><stop offset="100%" stop-color="#ffd27a"/></linearGradient></defs><rect width="120" height="120" rx="60" fill="url(#bg)"/><circle cx="60" cy="50" r="22" fill="#eaf4ff"/><path d="M29 104c5-22 18-34 31-34s26 12 31 34" fill="#eaf4ff"/><path d="M31 55c0-20 13-35 29-35s29 15 29 35" fill="none" stroke="url(#accent)" stroke-width="9" stroke-linecap="round"/><rect x="23" y="50" width="15" height="25" rx="7" fill="#F5A623"/><rect x="82" y="50" width="15" height="25" rx="7" fill="#F5A623"/><path d="M75 77c8 1 12 5 12 11" fill="none" stroke="#F5A623" stroke-width="5" stroke-linecap="round"/><circle cx="87" cy="90" r="4" fill="#F5A623"/></svg>'
)}`;
const API_ROOT = (process.env.REACT_APP_API_URL || "")
  .replace(/\/+$/, "")
  .replace(/\/api$/, "");

/**
 * Convierte cualquier ruta de upload del backend a una URL absoluta.
 * Devuelve "" si la ruta está vacía o no reconocida.
 * Úsalo para banners, imágenes de perfil, etc. (sin fallback visual).
 */
export function getUploadUrl(url) {
  if (!url || typeof url !== "string" || url.trim() === "") return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/backend/uploads/")) return API_ROOT ? `${API_ROOT}${url}` : url;
  if (url.startsWith("/api/")) return API_ROOT ? `${API_ROOT}${url}` : url;
  if (url.startsWith("/uploads/")) return API_ROOT ? `${API_ROOT}/backend${url}` : `/backend${url}`;
  // Blob URL (preview local) → usar tal cual
  if (url.startsWith("blob:")) return url;
  return "";
}

export function getAvatarUrl(avatar) {
  // 1️⃣ Sin avatar → default
  if (!avatar || typeof avatar !== "string" || avatar.trim() === "") {
    return DEFAULT_AVATAR;
  }

  if (avatar.includes("default-avatar.png")) {
    return DEFAULT_AVATAR;
  }

  // 2️⃣ URL absoluta (Cloudinary, CDN, etc.) → usar TAL CUAL
  if (/^https?:\/\//i.test(avatar)) {
    return avatar;
  }

  // 3️⃣ Ruta local actual del backend
  if (avatar.startsWith("/backend/uploads/")) {
    return API_ROOT ? `${API_ROOT}${avatar}` : avatar;
  }

  // 4️⃣ Avatar persistido en API (por ejemplo Mongo GridFS)
  if (avatar.startsWith("/api/")) {
    return API_ROOT ? `${API_ROOT}${avatar}` : avatar;
  }

  // 5️⃣ Compatibilidad LEGACY: avatars antiguos en /uploads
  // (solo por si queda alguno en DB)
  if (avatar.startsWith("/uploads/")) {
    return API_ROOT ? `${API_ROOT}/backend${avatar}` : `/backend${avatar}`;
  }

  // 6️⃣ Cualquier cosa rara → default
  return DEFAULT_AVATAR;
}
